module.exports = __webpack_public_path__ + "img/ZB53详情页_01.da74e933.jpg";